<div class="mt-8">

    <div *ngIf="article$ | async" class="w-full flex justify-end">

        <div class="grow">
            <button [routerLink]="['..']"
                class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
                Back
            </button>
        </div>

        <button [routerLink]="['edit']"
            class="bg-secondary-500 active:bg-primary-500 hover:bg-primary-300 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"><i class="fa fa-edit mr-2 leading-relaxed"></i>Edit Details
        </button>
    </div>

    <div *ngIf="article$ | async as article"
        class="flex flex-col w-full mb-6 my-4 shadow-lg items-center rounded-t bg-white border-0 p-4">
        <h1 class="text-4xl font-semibold text-primary-500 normal-case mb-2 text-left w-full max-w-[650px]">
            {{article.title}}
        </h1>
        <div class="flex items-center my-2 mx-auto w-full max-w-[650px]">
            <div class="inline-block flex-none">
                <img *ngIf="article.channelImageUrl" [src]="article.channelImageUrl"
                    class="min-h-10 max-h-10 max-w-10 min-w-10 bg-white rounded-full border-none" />
                <div *ngIf="!article.channelImageUrl"
                    class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                    {{article.channelName | initials}}
                </div>
            </div>
            <div class="flex-1 inline-flex flex-span ml-3 text-sm font-bold text-blueGray-600">
                <span>{{article.channelName}}</span>
            </div>
        </div>
        <div *ngIf="loading" class="max-w-[650px]">
            <div class="h-6 w-3/6 pr-8 rounded my-4">
                <ngx-skeleton-loader count="1" appearance="line" />
            </div>
            <div class="h-4 w-full px-6 rounded my-4">
                <ngx-skeleton-loader count="1" appearance="line" />
            </div>
            <div class="h-4 w-full px-6 rounded my-4">
                <ngx-skeleton-loader count="1" appearance="line" />
            </div>
            <div class="h-4 w-full px-6 rounded my-4">
                <ngx-skeleton-loader count="1" appearance="line" />
            </div>
        </div>
        <app-text-editor [readOnly]="true" #textEditor class="display:block container w-full mx-0"></app-text-editor>
    </div>
</div>